module.exports = __webpack_public_path__ + "static/media/shopping-cart.f7b0c85f.svg";